import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { UsefulLinksProvider } from '../useful-links/context/useful-links-context';
import { CartaServicosComponent } from './carta-servicos-component';

export function CartaServicosFactory() {
  return (
    <BaseLayoutFactory>
      <UsefulLinksProvider>
        <CartaServicosComponent />
      </UsefulLinksProvider>
    </BaseLayoutFactory>
  );
}
